import { USER_ROLES, UserRole } from '../domain/role'
import { User } from '../domain/user'

// Role sets
const managerRoles = ['admin', 'manager'] as const

export const hasRoles = (user: User, roles: UserRole[]): boolean =>
  (user.roles ?? []).some((userRole) => roles.some((role) => role === userRole))

export const authorize = {
  admins: ['admin'],
  managers: [...managerRoles],
  managerOrBilling: [...managerRoles, 'billing'],
  purchaseOrderOperators: ['purchaseOrderOperator'],
  all: [...USER_ROLES],
} satisfies Record<string, UserRole[]>
